import React from 'react';
import { TransportationOrderDataForm } from '../../../../app/models/TransportationOrder';
import { Link } from 'react-router-dom';
import { TransportationQuoteDetail } from '../../../../app/models/TransportationQuoteDetail';

interface Props {
    transportationOrderDataForm: TransportationOrderDataForm;
    quotes: TransportationQuoteDetail[];
    showProductField: boolean;

}

const TransportationOrderShowForm = ({ transportationOrderDataForm, quotes, showProductField=true }: Props) => {
    console.log(transportationOrderDataForm.payment_condition);
    return (
        <>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Oferta</label>
                <div className="col-md-9">
                    {transportationOrderDataForm.transportation_quote_detail_id ? (
                        <Link
                            to={`/quotes/${
                                quotes
                                    .find((item) => {
                                        return (
                                            item.id ==
                                            transportationOrderDataForm.transportation_quote_detail_id
                                        );
                                    })
                                    ?.name?.replace('#', '')
                                    .split('|')[0]
                            }/show`}
                        >
                            {
                                quotes.find((item) => {
                                    return (
                                        item.id ==
                                        transportationOrderDataForm.transportation_quote_detail_id
                                    );
                                })?.name
                            }
                        </Link>
                    ) : (
                        <input
                            type="text"
                            name="quote_id"
                            className="form-control"
                            readOnly={true}
                            value="No asignada"
                        />
                    )}
                </div>
            </div>

            {showProductField && (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Producto</label>
                    <div className="col-md-9">
                        <input
                            name="product_name"
                            id="product_name"
                            type="text"
                            className="form-control"
                            value={transportationOrderDataForm.product_name}
                            disabled
                        />
                    </div>
                </div>
            )}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Sociedad</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="society"
                        className="form-control"
                        readOnly={true}
                        value={transportationOrderDataForm.society}
                    />
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Cliente</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="client"
                        className="form-control"
                        readOnly={true}
                        value={transportationOrderDataForm.client}
                    />
                </div>
            </div>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Contacto</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="contact_email"
                        className="form-control"
                        readOnly={true}
                        value={transportationOrderDataForm.contact_email}
                    />
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Forma de Pago</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="payment_method"
                        className="form-control"
                        readOnly={true}
                        value={transportationOrderDataForm.payment_method}
                    />
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Condición de Pago</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="payment_condition"
                        className="form-control"
                        readOnly={true}
                        value={transportationOrderDataForm.payment_condition}
                    />
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Moneda</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="currency"
                        className="form-control"
                        readOnly={true}
                        value={String(transportationOrderDataForm.currency)}
                    />
                </div>
            </div>
        </>
    );
};

export default TransportationOrderShowForm;
